<template>
  <div class="page1">
    <EForm :formColumns="formColumns" :rowSize="5" :optionsBtn="true" :actionBtn="false" :formData="searchForm"
      ref="form" @onSearch="onSearch" :searchFlag="true" :exportShow="false"></EForm>
    <el-button @click="dialogVisible = true">新增</el-button>
    <el-button type="danger" size="small" plain @click="deleteMore">删除</el-button>
    <ETable :tableTitle="tableTitle" :tableData="tableData" :needPagination="true" :count="count"
      @changePage="changePage" @changeSize="changeSize" :page="searchForm.current" :page_size="searchForm.size" @handleSelect="handleSelectionChange"
            :needSelect="true">
      <el-table-column fixed="right" label="操作" width="180px">
        <template slot-scope="scope">
          <div>
            <el-button type="text" @click="editDialog(scope.row)">修改</el-button>
          </div>
        </template>
      </el-table-column>
      <div slot="testingResult" slot-scope="scope">
        {{ scope.data.testingResult == '合格' ? '合格' : '不合格' }}
      </div>
    </ETable>
    <EDialog :dialogVisible="dialogVisible" :title="title" @handleClose="handleClose" width="40%"
      @handleClick="saveData">
      <el-form label-position="right" label-width="100px" :model="form" :rules="formRules" ref="form">
        <el-row>
          <el-col :span="24">
            <el-form-item label="检测商品" prop="goodsName">
              <el-input v-model="form.goodsName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="检测时间" prop="testingTime">
              <el-date-picker
                v-model="form.testingTime"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择时间">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="检测结果" prop="testingResult">
              <el-radio-group v-model="form.testingResult">
                <el-radio label="合格">合格</el-radio>
                <el-radio label="不合格">不合格</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </EDialog>
  </div>
</template>

<script>
import ETable from '@/components/ETable'
import Http from "@/service/http";
import EDialog from '@/components/EDialog'
import EButton from '@/components/EButton'
import EForm from '@/components/EForm'
import vxRule from "@/assets/js/formValidate";
import { mapGetters } from 'vuex'

export default {
  name: 'Login',
  data() {
    return {
      formColumns: [
        {
          title: '检测商品',
          type: 'text',
          property: 'goodsName',
          placeHolder: '请输入',
          show: true,
        },
        {
          title: '检测结果',
          type: 'select',
          property: 'testingResult',
          show: true,
          options: [
            {
              label: '全部',
              value: '',
            },
            {
              label: '合格',
              value: '合格',
            },
            {
              label: '不合格',
              value: '不合格',
            },
          ],
        },],
      tableTitle: [
        {
          label: '检测商品',
          prop: 'goodsName',
        },
        {
          label: '检测时间',
          prop: 'testingTime',
        },
        {
          label: '创建时间',
          prop: 'createTime',
        },
        {
          label: '检测结果',
          prop: 'testingResult',
          type: 'slot'
        },],
      tableData: [],
      loading: false,
      dialogVisible: false,
      title: '添加信息',
      form: {
        id: '',
        goodsName: '',
        testingResult: '合格',
        testingTime: ''
      },
      searchForm: {
        goodsName: '',
        testingResult: '',
        current: 1,
        size: 10
      },
      cascader: false,
      options: [],
      count: null,
      formRules: {
        goodsName: [vxRule(true, '', "blur", "检测商品不能为空")],
        testingTime: [vxRule(true, '', "blur", "检测时间不能为空")],
      },
      labelPosition: 'right',
      labelWidth: '100px',
      selectRoutes: [],
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
  },
  watch: {},
  created() {
    this.getData()
    //this.getOptions()
  },
  components: { ETable, EDialog, EButton, EForm },
  beforeMount() {

  },
  methods: {
    onSearch() {
      this.searchForm.current = 1
      this.getData()
    },
    changePage(page) {
      this.searchForm.current = page
      this.getData()
    },
    changeSize(size) {
      this.searchForm.size = size
      this.getData()
    },
    handleClose() {
      this.title = '添加信息'
      this.dialogVisible = false
      this.form = {
        id: '',
        goodsName: '',
        testingTime: '',
        testingResult: '合格'
      }
      this.$refs.form.resetFields()
    },
    handleSelectionChange(data) {
        if (data.length > 0) {
          data.forEach((item) => {
            this.selectRoutes.push(item.id);
          });
        }
      },
    deleteMore() {
      this.deleteInfo(this.selectRoutes.toString());
    },
    deleteInfo(ids) {
      this.$messageBox
        .confirm(`确定删除该信息吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then((res) => {
          this.removeRoute(ids);
        })
        .catch((res) => {});
    },
    async getData() {
      let res = await Http.testingList(this.searchForm)
      if (res.code == 200) {
        this.tableData = res.data.records
        this.count = res.data.total
      }

    },
    saveData() {
      let flag = false
      this.$refs['form'].validate((valid, object) => {
        if (valid && !this.error) {
          flag = true
        } else {
          return false;
        }
      });
      if (flag) {
        this.addBtn()
      }
    },
    async addBtn() {
      let {
        id,
        goodsName,
        testingTime,
        testingResult
      } = this.form
      let res = await Http.testingSave({
        id,
        goodsName,
        testingTime,
        testingResult
      })
      if (res.code == 200) {
        this.$message.success(res.msg)
        this.handleClose()
        this.getData()
      }
    },
    editDialog(data) {
      this.title = '编辑信息'
      this.form = {
        id: data.id,
        goodsName: data.goodsName,
        testingTime: data.testingTime,
        testingResult: data.testingResult,
      }
      this.dialogVisible = true
    },
    async removeRoute(ids) {
      let res = await Http.testingRemoveRoute({ ids });
      if (res.code == 200) {
        this.$message.success(res.msg);
        this.getData();
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.title {
  font-size: 16px;
  padding: 10px 0;
  border-bottom: 1px solid #DCDFE6;
  margin-bottom: 20px;
  color: #333;
  font-weight: bold;

}
</style>
